import { SchmancyElement } from '@schmancy/mixins/index'
import { html } from 'lit'
import { customElement, query } from 'lit/decorators.js'
import '@schmancy/primitives/button/button'
import '@schmancy/primitives/icons/icon'

@customElement('schmancy-theme-button')
export default class SchmancyThemeButton extends SchmancyElement {
	@query('#color') color!: HTMLElement

	protected render(): unknown {
		return html`
			<schmancy-button
				@click=${() => {
					this.color.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], {
						duration: 300,
					})
				}}
				variant="text"
			>
				<schmancy-icon id="color">palette</schmancy-icon>
			</schmancy-button>
		`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-theme-button': SchmancyThemeButton
	}
}
